import { Grid, TextField, Autocomplete, Button } from '@mui/material';
import { useAnalyzerModules } from 'features/analyzerModules/api/getAnalyzerModules';
import { Control, Controller } from 'react-hook-form';
import { SystemPageFilters } from './types';
import { getUniqueModuleTypes } from './utils/tableHelpers';

interface Props {
  control: Control<SystemPageFilters>;
  clearFilters: () => void;
}

const AnalyzerFilters = ({ control, clearFilters }: Props) => {
  const { data: modules } = useAnalyzerModules({});
  const uniqueModules = getUniqueModuleTypes(modules);

  return (
    <>
      <Controller
        name='analyzerName'
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <Grid item>
            <TextField
              name='device'
              label='Filter By Device Name'
              variant='outlined'
              value={value}
              onChange={onChange}
            />
          </Grid>
        )}
      />
      <Controller
        name='analyzerSerial'
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <Grid item>
            <TextField
              name='serial'
              label='Filter By Serial'
              variant='outlined'
              value={value}
              onChange={onChange}
            />
          </Grid>
        )}
      />
      <Controller
        name='module'
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <Grid item>
            <Autocomplete
              onChange={(event, value) => onChange(value)}
              value={value}
              options={uniqueModules}
              getOptionLabel={(module) => module}
              style={{ width: 230 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label='Filter By Module'
                  variant='outlined'
                />
              )}
            />
          </Grid>
        )}
      />
      <Grid item>
        <Button variant='contained' color='primary' onClick={clearFilters}>
          Clear Filters
        </Button>
      </Grid>
    </>
  );
};

export default AnalyzerFilters;
